import api from "./api";

class ShopBackService {
    /**
     * Create a ShopBack dynamic-QR order for an existing kiosk transaction.
     * @param {Object} dataForm { transaction_id, amount, receipt_no, branch_code, member_id }
     */
    createOrder(dataForm) {
        return api.post("/shopback/create-order", dataForm);
    }

    /**
     * Poll order status (CREATED / PENDING / PROCESSING / CAPTURED / FAILED / CANCELLED / ABANDONED).
     * @param {Object} dataForm { reference_id }
     */
    getStatus(dataForm) {
        return api.post("/shopback/get-status", dataForm);
    }

    /**
     * Cancel a pending order. Backend refuses to cancel once the customer
     * has swiped-to-pay (PROCESSING/CAPTURED) — check the response's
     * `cancelled` flag rather than assuming success.
     * @param {Object} dataForm { reference_id }
     */
    cancel(dataForm) {
        return api.post("/shopback/cancel", dataForm);
    }
}

export default new ShopBackService();
